import { useEffect, useRef, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { actions as authActions } from 'features/Auth';

export const useNotificationsObserver = ({ notifications }) => {
  const observerRef = useRef(null);
  const dispatch = useDispatch();
  const [observedItems, setObservedItems] = useState(new Set());

  const addUniqueIdToLocalStorage = (id) => {
    const seenNotifications = new Set(
      JSON.parse(localStorage.getItem('seendNotofications') || '[]')
    );
    if (!seenNotifications.has(id)) {
      seenNotifications.add(id);
      dispatch(authActions.addSeenNotifications(id));
      localStorage.setItem('seendNotofications', JSON.stringify([...seenNotifications]));
    }
  };

  const handleIntersection = useCallback(
    (entries) => {
      entries.forEach((entry) => {
        const id = entry.target.getAttribute('data-id');
        if (id && entry.isIntersecting && !observedItems.has(id)) {
          addUniqueIdToLocalStorage(id);
          setObservedItems((prev) => new Set(prev).add(id));
        }
      });
    },
    [observedItems]
  );

  useEffect(() => {
    if (!observerRef.current) {
      observerRef.current = new IntersectionObserver(handleIntersection, {
        root: null,
        threshold: 0.7, // Уровень пересечения
      });
    }

    const observer = observerRef.current;

    const targets = document.querySelectorAll('[data-id]');
    targets.forEach((target) => observer.observe(target));

    return () => {
      observer.disconnect();
    };
  }, [handleIntersection, notifications]);

  return null;
};
